import { ItineraryCheckupErrors } from './../itinerary-checker.service';
import { Itinerary } from './../itineray.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'app-itinerary-checkup-dialog',
  templateUrl: './itinerary-checkup-dialog.component.html',
  styleUrls: ['./itinerary-checkup-dialog.component.css']
})
export class ItineraryCheckupDialogComponent implements OnInit {

  isItineraryValid: boolean = null;

  constructor(@Inject(MAT_DIALOG_DATA) public itineraryCheckupErrors: ItineraryCheckupErrors, private matDialogRef: MatDialogRef<ItineraryCheckupDialogComponent>, ) { }

  ngOnInit() {
  }

  close(): void {
    this.matDialogRef.close();
  }

}
